<app-events-dropdown-list
  [searchTermDataCallback]="autocompleteEvents"
  [dateByFilterDataCallBack]="dateFilterEvents"
  [minCharacterRequiredForSearch]="minCharacterRequiredForSearch"
  [optionListMaxHeight]="'340px'"
  [highlightedDates]="highlightedDates$ | async"
  (sessionChanged)="sessionChanged($event)"
  (monthChanged)="getEventsByMonth($event)"
  data-cy="orders-filters-event-dropdown"
></app-events-dropdown-list>
